import React from 'react'
import ReactDOM from 'react-dom'
import Link, { withPrefix } from 'gatsby-link'
import { observer, inject } from 'mobx-react'
import { autorun, toJS } from 'mobx'
import {
  Grid,
  Container,
  Dropdown,
  Header,
  Image,
  Icon,
  Message,
  Button,
} from 'semantic-ui-react'
import { Form } from 'formsy-semantic-ui-react'
import { isMobile } from 'react-device-detect'
import { parse as qsParse } from 'query-string'
import CountUp from 'react-countup'

@inject('UserStore')
@observer
class AccountPage extends React.Component {
  componentWillMount() {
    this.props.UserStore.fetchMe()
  }
  componentDidMount() {
    const that = this
    const { code: passwordResetCode } = qsParse(this.props.location.search)
    if (passwordResetCode) {
      this.props.UserStore.passwordResetCode = passwordResetCode
    }
  }

  render() {
    const { loading, pwdResetLoading, success, err, handleChange } = this.props.UserStore
    const { firstName, email, password, amount, user, topup } = this.props.UserStore
    const { login, requestPasswordReset, logout } = this.props.UserStore
    const { passwordResetCode, setNewPassword } = this.props.UserStore

    if (user) {
      return (
        <Container text textAlign='left'>
          <Header as='h2' textAlign='left' content='Your account' />
          <p>Hi {user.email}</p>
          <Form>
            <Form.Group inline>
              <Form.Input
                name='amount'
                placeholder='50.00'
                type='number'
                width={4}
                icon='dollar'
                iconPosition='left'
                onChange={handleChange}
                required
                defaultValue={amount}
              />
              <Button
                type='submit'
                color='green'
                onClick={topup}
                content='Top up now'
                {...{ loading }}
              />
            </Form.Group>
          </Form>
          <p>
            Your balance is:{' '}
            <CountUp end={user.balance / 100} decimals={2} duration={1} prefix='$' />
            <br />
            <br />
            We offer 30% bonus on purchases above 50 USD. Example: spend $100 - get $130
            in balance. By topping up now, you'll save time and money in the future.
            <br />
            <br />
            If you have requests or comments, please{' '}
            <a
              onClick={() => {
                window.open('mailto:hello' + '@' + 'fakeflighttickets.com', '_blank')
              }}
              target='_blank'>
              contact us
            </a>
            .
          </p>
          <Button
            basic
            onClick={logout}
            content='Log out'
            style={{ marginTop: '15vh', display: 'block' }}
          />
        </Container>
      )
    }

    return (
      <React.Fragment>
        <Container text textAlign='left'>
          {Boolean(passwordResetCode) ? (
            <React.Fragment>
              <Header as='h2' textAlign='left' content='Set a new password' />
              <Form error={Boolean(err)}>
                <Form.Input
                  label='Password'
                  name='password'
                  placeholder='Password'
                  type='password'
                  onChange={handleChange}
                />
                <Form.Input
                  label='Repeat your password'
                  name='passwordRepeat'
                  placeholder='Password'
                  type='password'
                  onChange={handleChange}
                />
                <Button
                  content='Set password'
                  color='green'
                  onClick={setNewPassword}
                  {...{ loading }}
                />
                <Message error header={err && err.message} />
              </Form>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Header as='h2' textAlign='left' content='Log in' />
              <p className='hero'> </p>
              <Form error={Boolean(err)} success={Boolean(success)}>
                <Form.Input
                  label='Email'
                  name='email'
                  placeholder='your@email.com'
                  type='email'
                  onChange={handleChange}
                />
                <Form.Input
                  label='Password'
                  name='password'
                  placeholder='Password'
                  type='password'
                  onChange={handleChange}
                />
                <Button content='Login' color='green' onClick={login} {...{ loading }} />
                <Button
                  floated='right'
                  basic
                  onClick={requestPasswordReset}
                  loading={pwdResetLoading}>
                  Register
                </Button>
                <Button
                  floated='right'
                  basic
                  onClick={requestPasswordReset}
                  loading={pwdResetLoading}>
                  Forgot password?
                </Button>
                <Message error header={err && err.message} />
                <Message success header={success && success.message} />
              </Form>
            </React.Fragment>
          )}
          <div style={{ marginTop: '3em' }} />
        </Container>
      </React.Fragment>
    )
  }
}

export default AccountPage



// WEBPACK FOOTER //
// ./src/pages/account.jsx